import {all, fork } from 'redux-saga/effects';
import authSagas from './authSagas';
import employeesSagas from './employeesSagas';

export function* rootSaga() {
    return yield all([
            fork(authSagas),
            fork(employeesSagas),
        ]
    );
}
